module.exports = __webpack_public_path__ + "3-68.jpg?3dc6e442dcf2cd0b9bd9d4c85e913917";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-68.jpg
// module id = 150
// module chunks = 0